import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { CircleCheckBig } from "lucide-react";
import AzureUserConnection from "./AzureUserConnection";

const AzureSetting = ({ appInfo }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"w-40"}>{t("Microsoft Profile")}</div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          <AzureUserConnection />
        </div>
        <div className="col-span-12 lg:col-span-2">
          {appInfo.connected && (
            <div className="flex items-center justify-end mr-4 connected-anchor-element">
              <CircleCheckBig className="w-5 h-5 text-green-400 mr-2" />
              <Tooltip anchorSelect=".connected-anchor-element" content={t("Connected")} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AzureSetting;
